import apiClient from './api'

export interface AuditLogFilters {
  user?: string
  action?: string
  entityType?: string
  entityId?: string
  startDate?: string
  endDate?: string
  search?: string
  page?: number
  pageSize?: number
}

export interface AuditLog {
  id: string
  timestamp: string
  user: string
  action: string
  entityType: string
  entityId: string
  changes?: Record<string, { old: any; new: any }>
  ipAddress?: string
  userAgent?: string
  metadata?: Record<string, any>
}

export interface AuditLogResponse {
  logs: AuditLog[]
  total: number
  page: number
  pageSize: number
}

export const auditService = {
  // Fetch audit logs with filters
  fetchAuditLogs: async (filters: AuditLogFilters): Promise<AuditLog[]> => {
    try {
      const params: Record<string, any> = {}
      if (filters.user) params.user = filters.user
      if (filters.action) params.action = filters.action
      if (filters.entityType) params.entity_type = filters.entityType
      if (filters.entityId) params.entity_id = filters.entityId
      if (filters.startDate) params.start_date = filters.startDate
      if (filters.endDate) params.end_date = filters.endDate
      if (filters.search) params.search = filters.search
      if (filters.page) params.page = filters.page
      if (filters.pageSize) params.page_size = filters.pageSize

      const response = await apiClient.get('/admin/audit-logs', { params })
      return response.data.logs || response.data || []
    } catch (error) {
      console.error('Failed to fetch audit logs', error)
      // Return empty array if endpoint doesn't exist yet
      return []
    }
  },

  // Get audit log by ID
  getAuditLog: async (id: string): Promise<AuditLog | null> => {
    try {
      const response = await apiClient.get(`/admin/audit-logs/${id}`)
      return response.data
    } catch (error) {
      console.error('Failed to fetch audit log', error)
      return null
    }
  },

  // Get audit logs for a specific entity
  getEntityAuditLogs: async (entityType: string, entityId: string): Promise<AuditLog[]> => {
    try {
      const response = await apiClient.get('/admin/audit-logs', {
        params: {
          entity_type: entityType,
          entity_id: entityId,
        },
      })
      return response.data.logs || response.data || []
    } catch (error) {
      console.error('Failed to fetch entity audit logs', error)
      return []
    }
  },
}


